import smartlookClient from 'smartlook-client';

import { isProd } from '../config/config';

export type SmartlookEventInformation = {
  /**
   * The action the user is taking. Make this string in human readable format in Title Case. Bundle multiple buttons of the same action together with the same eventName and differentiate them using a prop.
   * @example 'User Identification Response'
   */
  eventName: string;
  /**
   * Additional properties included with the custom event whenever it's fired. Key names are camelCased. These props will be used to breakdown events for comparison in Smartlook and can be used for filtering.
   * @example { messageType: 'email', templateUsed: true, ... }
   */
  props: {
    [key: string]: string | number | boolean;
  };
};

const smartlookDefaultEmptyValue = 'EMPTY_PROPERTY';

export const trackWithSmartlook = (event: SmartlookEventInformation, customEmptyValue?: string) => {
  const { eventName, props } = event;
  Object.keys(props).forEach((k) => {
    // Smartlook removes empty values from the event properties
    // To fully report the user input, we want to replace null, undefined, and empty strings with a default empty value
    if (!props[k] && !['boolean', 'number'].includes(typeof props[k])) {
      props[k] = customEmptyValue || smartlookDefaultEmptyValue;
    }
  });

  if (isProd) {
    smartlookClient.track(eventName, props);
  } else {
    // eslint-disable-next-line no-console
    console.log(`[mock] Smartlook event: ${eventName}`, props);
  }
};
